// extracted by mini-css-extract-plugin
export default {"default":"experts-comment_default__f5FDv","shift":"experts-comment_shift__9fT77","text":"experts-comment_text__QrrhD"};